import { notificationService } from "./../../service/notification.service";
import { Component, OnInit, ViewChild, TemplateRef, ElementRef, group, HostListener } from "@angular/core";
import { NgbModal, ModalDismissReasons, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { Router, ActivatedRoute } from "@angular/router";
import { GroupService } from "../../service/group.service";
import { HttpErrorResponse } from "@angular/common/http";
import { Globals } from "../.././globals";
import { commonService } from "../../service/common.service";
import { FileSelectDirective, FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
declare var CKEDITOR: any;
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { data } from "../../table/smart-table/smart-data-table";
import { flatMap } from "rxjs/operators";
@Component({
  selector: "app-groupdetail",
  templateUrl: "./groupdetail.component.html",
  styleUrls: ["./groupdetail.component.css"],
  providers: [GroupService, notificationService]
})
export class GroupdetailComponent implements OnInit {
  @ViewChild("ckeditor") ckeditor: any;
  @ViewChild('studentcenterbox', { read: ElementRef }) studentcenterbox: ElementRef;
  @ViewChild('postattachedimg', { read: ElementRef }) postattachedimg: ElementRef;
  modalReference: NgbModalRef;
  groupId: any;
  groupDetails: any;
  user: any;
  groupmemberdetails: any = [];
  readonly path = this.global.groupProfileUrl;
  readonly profileUrl = this.global.profileUrl;
  profileurl = this.global.profileUrl;
  actions: string[] = ['User', 'Batch'];
  action = 'User';
  searchtxt: any;
  userlist: any = [];
  groupbatchdetails: any = [];
  viewmore = false;
  actionBox: any;
  search: any;
  msg: any;
  isError = false;
  isSuccess = false;
  groupmember: any = {};
  newconversationbox = false;
  content: any;
  feedData: any = [];
  feedviewmore = false;
  onlineUser: any = [];
  commentEditbox: any;
  commentbox: any;
  replybox: any;
  contentbox: any;
  ckeConfig: any;
  isclickViewMore = false;
  isclickbuttonPost = false;
  msgpopup: any;
  modalReferenceImg: any;
  ckeditorevent: any;
  ispasscode = false;
  attachmentUrl = this.global.siteUrl + 'file/upload?folder=' + this.global.postAttachmentFolder + '&mediaFor=userPost';
  ImageattachmentUrl = this.global.siteUrl + 'file/upload?folder=ckeditor&mediaFor=ckeditor';
  imageuploaders: FileUploader = new FileUploader({ url: this.ImageattachmentUrl, authToken: localStorage.getItem('_to') });;
  @ViewChild('group') public creategroup: TemplateRef<any>;
  @ViewChild('postbox') public postbox: ElementRef;
  @ViewChild('actionbutton') public actionbutton: ElementRef;
  @ViewChild('postcontentbox') public postcontentbox: ElementRef;
  //@ViewChild('invitemember') public invitemember:ElementRef;
  iframeTitle: String = '';
  feedid:any;
  searchUserInput:any;
  progress:any;
  constructor(private http: HttpClient,private _common: commonService, private global: Globals, private _group: GroupService, private modalService: NgbModal, private router: Router, private route: ActivatedRoute, private notificationService: notificationService) {
    this.commentEditbox = {};
    this.commentbox = {};
    this.replybox = {};
    this.contentbox = {};
    this.imageuploaders.onErrorItem = (item, response, status, headers) => this.onErrorItemImage(item, response, status, headers);
    this.imageuploaders.onSuccessItem = (item, response, status, headers) => this.onSuccessItemImage(item, response, status, headers);
    this.feedid=0;
    this.searchUserInput={};
  }



  ngOnInit() {
    this.route.params.subscribe(params => {
      //  this.groupId = atob(decodeURIComponent(params.id)); 
      this.groupId = params.id;
      this.feedid= (params.feedid==undefined)?0:params.feedid;
      this.getGroupDetails();
      this.getgroupmemberdetails();
     
    })



    // getOnlineUser
    this._common.getOnlineUser.subscribe((data: any) => {
      this.onlineUser = data;

    })

    // get user details
    this._common.profile.subscribe((data: any) => {
      //this.user = data;
      //this.userData= true;;
      if (data) {
        this.user = data;
        this.getGroupDetails();
        this.getgroupmemberdetails();
      } else {
        this.user = {};
        
      }
    });

    // getOnlineUser
    this._common.getOnlineUser.subscribe((data: any) => {
      this.onlineUser = data;
    });



    this.ckeConfig = {
      height: 100,
      language: "en",
      image_previewText: '',
      allowedContent: true,
      extraPlugins: 'uploadimage',

      mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js?config=TeX-AMS_HTML',
      // allowedContent: true,
      // extraPlugins: "divarea",
      toolbar: [
        // { name: "editing", items: ["Scayt", "Find", "Replace", "SelectAll"] },
        // { name: "clipboard", items: ["Cut", "Copy", "Paste", "PasteText", "PasteFromWord", "-", "Undo", "Redo"] },
        { name: "links", items: ["Link", "Unlink", "Anchor"] },
        //  { name: "tools", items: ["Maximize", "ShowBlocks", "Preview", "Print", "Templates"] },
        // { name: "document", items: ["Source"] },
        { name: "insert", items: ["Image", "customImageupload", "Table", "HorizontalRule", "SpecialChar", "Iframe", "imageExplorer"] },
        //{ name: "insert", items: ["Image", "Table",  "imageExplorer","Iframe"] },
        // For New Line  "/",
        { name: "basicstyles", items: ["Bold", "Italic", "Underline", "Strike", "Subscript", "Superscript", "-", "RemoveFormat"] },
        { name: "paragraph", items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent", "Blockquote"] },
        // { name: "justify", items: ["JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock"] },
        //  { name: "styles", items: ["Styles", "Format", "FontSize", "-", "TextColor", "BGColor"] }
      ],
      filebrowserUploadUrl: this.global.objectStorage + 'ckeditor/upload'
    };
    CKEDITOR.on('dialogDefinition', function (event) {
      // console.log('editDialog');

      var dialogName = event.data.name;
      var dialogDefinition = event.data.definition;
      //some code here  
      if (dialogName == 'iframe') { // flash dialog box name 
        dialogDefinition.removeContents('advanced');
        // dialogDefinition.removeContents('target');

        // console.log('def', dialogDefinition);  //"advStyles""advCSSClasses"
        dialogDefinition.title = 'Share video link from YouTube or Vimeo';

        dialogDefinition.minHeight = 100;

        dialogDefinition.onShow = function () {
          this.getContentElement("info", "align").getElement().hide();
          this.getContentElement("info", "scrolling").getElement().hide();
          this.getContentElement("info", "frameborder").getElement().hide();
          this.getContentElement("info", "name").getElement().hide();
          this.getContentElement("info", "title").getElement().hide();
          //this.getContentElement("info","longdesc").disable(); // for disabling input
          this.getContentElement('info', 'longdesc').getElement().hide();
        }
      }
    });
  }

  getGroupDetails() {
    this._group.getGroupDetails({ group: this.groupId, userId: this.user ? this.user.id : 0 }).subscribe(
      (data: any) => {
        if (data.error == 0) {
          this.groupDetails = data.results;
          // console.log(data.results);
          if (data.results.groupUsers.length > 0 && data.results.groupUsers[0].status == "request") {
            //this.actionbutton.nativeElement.innerHTML = "Cancel Request";
            // this.postbox.nativeElement.remove();
            //this.postcontentbox.nativeElement.remove();
            // this.invitemember.nativeElement.remove();
          } else if (data.results.groupUsers.length > 0 && data.results.groupUsers[0].status == "cancel") {
            // this.actionbutton.nativeElement.innerHTML = "Join Group";
            // this.postbox.nativeElement.remove();
            // this.postcontentbox.nativeElement.remove();
            //this.invitemember.nativeElement.remove();
          } else if (data.results.groupUsers.length > 0 && data.results.groupUsers[0].status == "confirmed") {
            // this.actionbutton.nativeElement.remove();
            this.actionbutton.nativeElement.innerHTML = "Leave Group";
            this.groupfeed();

            if (data.results.createdBy != this.user.id) {
              //  this.invitemember.nativeElement.remove();
            }


            if (this.groupDetails.groupPrivacy == "Private" && this.groupDetails.createdBy != this.user.id) {
              // this.invitemember.nativeElement.remove();
            }
          } else if (data.results.createdBy == this.user.id) {
            this.actionbutton.nativeElement.remove();
            this.groupfeed();
          } else if (data.results.groupUsers.length == 0 && this.groupDetails.groupPrivacy == "Private" && Object.keys(this.user).length > 0) {
            this.actionbutton.nativeElement.innerHTML = "Join with Pass-code";
            //this.invitemember.nativeElement.remove();
          } else {
            // console.log('11111111>>>>>>>>>>>>>>');
            //   console.log(Object.keys(this.user).length)
            // this.postbox.nativeElement.remove();
            // this.postcontentbox.nativeElement.remove();
            // this.invitemember.nativeElement.remove();
          }
        } else {
          if (data.message == "Failed to authenticate token.") {
            this.router.navigate(["/"]);
          } else {
            //this.msg = data.message;
            // this.isError = true;
            // this.isSuccess = false;
          }
        }
      },
      (error: HttpErrorResponse) => {
        //  this.isError = true;
        //this.msg="internal server error!";
      }
    );
  }

  getgroupmemberdetails() {
    this._group.getgroupmemberdetails({ group: this.groupId, userId: this.user ? this.user.id : 0 }).subscribe(
      (data: any) => {
        if (data.error == 0) {
          this.groupmember = data.results;
        } else {
          if (data.message == "Failed to authenticate token.") {
            this.router.navigate(["/"]);
          } else {
            //this.msg = data.message;
            // this.isError = true;
            // this.isSuccess = false;
          }
        }
      },
      (error: HttpErrorResponse) => {
        //  this.isError = true;
        //this.msg="internal server error!";
      }
    );
  }
  requesttojoin() {
    if (Object.keys(this.user).length == 0) {
      this._common.setLoginBox(true);
      return;
    }

    if (this.actionbutton.nativeElement.innerHTML == "Join Group") {
      var stauts = "REQUEST_JOIN";
    } else if (this.actionbutton.nativeElement.innerHTML == "Leave Group") {
      var stauts = "REQUEST_CANCEL";
    } else if (this.actionbutton.nativeElement.innerHTML == "Join with Pass-code") {
      var stauts = "REQUEST_JOIN";
      this.ispasscode = true;
      return false;
    } else {
      alert("Somthing went wrong.Please try to latter.");
      return false;
    }

    this._group.requestoJoin({ group: this.groupId, status: stauts, userId: this.user ? this.user.id : 0 }).subscribe(
      (data: any) => {
        if (data.error == 0) {
          this.getGroupDetails();
          this.getgroupmemberdetails();
          if (this.actionbutton.nativeElement.innerHTML == "Join Group") {
            // this.actionbutton.nativeElement.innerHTML = "Cancel Request";
            /*  this.notificationService.requestToJoinGroup(
                this.groupDetails,
                this.user,
                true
              );*/

          } else {
            this.actionbutton.nativeElement.innerHTML = "Join Group";
            /*this.notificationService.requestToJoinGroup(
              this.groupDetails,
              this.user,
              false
            );*/
          }
        } else {
          if (data.message == "Failed to authenticate token.") {
            this.router.navigate(["/"]);
          } else {
            alert(data.message);
          }
        }
      },
      (error: HttpErrorResponse) => {
        //  this.isError = true;
        //this.msg="internal server error!";
      }
    );
  }
  openGroupForm(content) {
    if (content != null) {
      this.modalReference = this.modalService.open(content, {
        size: "lg",
        backdrop: "static",
        keyboard: false
      });
    }
    this.actionBox = "User";
    this.getUser();
  }

  filteruser(search, actiontxt) {
    /* console.log(actiontxt);
   
   */
    var searchtxt = search.trim();
    if (searchtxt != "") {
      this._group
        .filteruser({
          search: searchtxt,
          action: actiontxt,
          group: this.groupId
        })
        .subscribe(
          (data: any) => {
            if (data.error == 0) {
              if (actiontxt == "User") {
                this.groupmemberdetails = data.results.rows;
              } else {
                this.groupbatchdetails = data.results.rows;
              }
            } else {
              if (data.message == "Failed to authenticate token.") {
                this.router.navigate(["/"]);
              } else {
              }
            }
          },
          (error: HttpErrorResponse) => {
            //  this.isError = true;
            //this.msg="internal server error!";
          }
        );
    } else {
      this.groupmemberdetails = [];
    }
  }

  putdata(objData, event, action) {
    this.searchtxt = event.target.innerHTML;
    this.groupmemberdetails = [];
    this.userlist = [];
    this.groupbatchdetails = [];

    this.actionBox = action;
    this.search = objData;

    if (this.actionBox == "User") {
      this.viewmore = false;
      this.userlist.push(this.search);
    } else {
      this._group
        .batchuser({ batch: this.search.id, group: this.groupId })
        .subscribe(
          (data: any) => {
            if (data.error == 0) {
              this.userlist = data.results.rows;

              if (data.results.count > this.userlist.length) {
                this.viewmore = true;
              } else {
                this.viewmore = false;
              }
            } else {
              if (data.message == "Failed to authenticate token.") {
                this.router.navigate(["/"]);
              } else {
              }
            }
          },
          (error: HttpErrorResponse) => { }
        );
    }
  }

  usertype(event) {
    this.isError = false;
    this.searchtxt = "";
    this.userlist = [];
    this.search = "";
    this.actionBox = event.target.options[event.target.selectedIndex].text;
    this.getUser();
  }

  getUser() {
    this.isError = false;
    this.groupmemberdetails = [];
    this.groupbatchdetails = [];

    if (this.actionBox == "User") {
      this._group
        .filteruser({
          search: "",
          group: this.groupId,
          action: this.actionBox,
          offset: this.userlist.length ? this.userlist.length : 0
        })
        .subscribe(
          (data: any) => {
            if (data.error == 0) {
              Array.prototype.push.apply(this.userlist, data.results.rows);
              if (data.results.count > this.userlist.length) {
                this.viewmore = true;
              } else {
                this.viewmore = false;
              }
            } else {
              if (data.message == "Failed to authenticate token.") {
                this.router.navigate(["/"]);
              } else {
              }
            }
          },
          (error: HttpErrorResponse) => { }
        );
    } else {
      var batch = "";
      if (this.search) {
        batch = this.search.id;
      }

      this._group
        .batchuser({
          batch: batch,
          offset: this.userlist.length ? this.userlist.length : 0,
          group: this.groupId
        })
        .subscribe(
          (data: any) => {
            if (data.error == 0) {
              Array.prototype.push.apply(this.userlist, data.results.rows);
              if (data.results.count > this.userlist.length) {
                this.viewmore = true;
              } else {
                this.viewmore = false;
              }
            } else {
              if (data.message == "Failed to authenticate token.") {
                this.router.navigate(["/"]);
              } else {
                //this.msg = data.message;
                // this.isError = true;
                // this.isSuccess = false;
              }
            }
          },
          (error: HttpErrorResponse) => {
            //  this.isError = true;
            //this.msg="internal server error!";
          }
        );
    }
  }

  invitation(formObj) {
    var pObj = [];
    $("input:checkbox:checked").each(function () {
      var sThisVal = $(this).val();
      if (sThisVal != "on") {
        pObj.push(sThisVal);
      }
    });
    if (!this.isEmpty(pObj)) {
      //this.notificationService.bulkInviteToJoinGroup(this.groupDetails, pObj, this.user);
      this._group
        .addinvitation({ group: this.groupId, requestData: pObj })
        .subscribe(
          (data: any) => {
            if (data.error == 0) {
              this.userlist = [];
              this.modalReference.close();
              // this.groupmemberdetails = data.results;
            } else {
              if (data.message == "Failed to authenticate token.") {
                this.router.navigate(["/"]);
              } else {
                this.msg = data.message;
                this.isError = true;
                this.isSuccess = false;
              }
            }
          },
          (error: HttpErrorResponse) => {
            this.isError = true;
            this.msg = "internal server error!";
          }
        );
    } else {
      this.msg = "No user are selected. please select at least one user";
      this.isError = true;
    }
  }
  isEmpty(obj) {
    for (var prop in obj) {
      if (obj.hasOwnProperty(prop)) return false;
    }
    return true;
  }

  viewmoreuser() {
    this.getUser();
  }

  newconversation() {
    this.newconversationbox = true;
  }

  newconversationpost(formData) {
    if (formData.status == "INVALID") {
    } else {
      this.isclickbuttonPost = true;
      formData.value["group"] = this.groupId;
      formData.value["content"] = this._common.checkvideo(formData.value.content);

      this._group.addNewPostGroup(formData.value).subscribe(
        (data: any) => {
          this.isclickbuttonPost = false;
          if (data.error == 0) {
            this.content = "";
            this.newconversationbox = false;
            var postId = data.postId;
            var objPost = {};
            objPost["id"] = postId;
            objPost["groupId"] = this.groupId;
            objPost["postContent"] = this._common.checkvideo(formData.value.content);
            objPost["createdAt"] = new Date();
            objPost["userId"] = this.user.id;
            objPost["user"] = {
              id: this.user.id,
              firstName: this.user.firstName,
              lastName: this.user.lastName,
              photo: this.user.photo,
              email: this.user.email
            };
            this.feedData.unshift(objPost);
          } else {
            if (data.message == "Failed to authenticate token.") {
              this.router.navigate(["/"]);
            } else {
              this.msg = data.message;
              this.isError = true;
              this.isSuccess = false;
            }
          }
        },
        (error: HttpErrorResponse) => {
          this.isError = true;
          this.msg = "internal server error!";
        }
      );
    }
  }
  groupfeed() {
    this.isclickViewMore = true;
    this._group
      .groupfeed({
        group: this.groupId,
        limit: 10,
        offset: this.feedData.length ? this.feedData.length : 0,
        userId: this.user ? this.user.id : 0,
        feedid:this.feedid
      })
      .subscribe(
        (data: any) => {
          this.isclickViewMore = false;
          if (data.error == 0) {
            Array.prototype.push.apply(this.feedData, data.results.rows);
            if (data.results.count > this.feedData.length) {
              this.feedviewmore = true;
            } else {
              this.feedviewmore = false;
            }
          } else {
            if (data.message == "Failed to authenticate token.") {
              this.router.navigate(["/"]);
            } else {
              this.msg = data.message;
              this.isError = true;
              this.isSuccess = false;
            }
          }
        },
        (error: HttpErrorResponse) => {
          this.isError = true;
          this.msg = "internal server error!";
        }
      );
  }

  datediff(date) {
    return this._common.datediff(date);
  }

  /*=============================== Like =================*/
  postLike(feed, react) {
    if (Object.keys(this.user).length == 0) {
      // this.needLogin();
      return false;
    }
    var obj = {};
    obj["userId"] = this.user.id;
    obj["postId"] = feed.id;
    obj["react"] = react;
    this._group.savePostLike(obj).subscribe(
      (data: any) => {
        if (data.error == 0) {
          this.postLikefunc(feed, react, data.message);
        }
      },
      (error: HttpErrorResponse) => {
        this.msg = "internal server error!";
      }
    );
  }

  postLikefunc(postObj, react, action) {
    if (!postObj.groupLikeCount) {
      postObj.groupLikeCount = 0;
    }
    if (!postObj.groupunLikeCount) {
      postObj.groupunLikeCount = 0;
    }

    // react=0 unlike
    if (react == 0 && action == "added") {
      postObj.mylike = 0;
      postObj.groupunLikeCount += 1;
      postObj.mylikeAction = "Unlike";
    } else if (react == 0 && action == "updated") {
      postObj.mylike = 0;
      postObj.groupLikeCount -= 1;
      postObj.groupunLikeCount += 1;
      postObj.mylikeAction = "Unlike";
    } else if (react == 1 && action == "added") {
      postObj.mylike = 1;
      postObj.groupLikeCount += 1;
      postObj.mylikeAction = "Like";
    } else if (react == 1 && action == "updated") {
      postObj.mylike = 1;
      postObj.groupLikeCount += 1;
      postObj.groupunLikeCount -= 1;
      postObj.mylikeAction = "Like";
    } else if (react == 0 && action == "removed") {
      // console.log('111111111');
      postObj.mylike = 0;
      postObj.groupunLikeCount -= 1;
      postObj.mylikeAction = "";
    } else if (react == 1 && action == "removed") {
      //  console.log('22222222');
      postObj.mylike = 0;
      postObj.groupLikeCount -= 1;
      postObj.mylikeAction = "";
    }

    //  console.log(postObj);
  }

  showPostcomment(feed) {
    if (feed.showAnscomment == true) {
      feed.showAnscomment = false;
      return false;
    }
    if (!feed.commentList || feed.commentList.length == 0) {
      this.loadComment(feed, "Comment", "");
    }
    feed.showAnscomment = true;
  }

  loadComment(feed, forcall, divobject) {
    if (!feed.commentList) {
      feed.commentList = [];
    }

    if (feed.commentCount > feed.commentList.length) {
      feed.isCommentLoad = true;
      var obj = {};
      if (this.user) obj["userId"] = this.user.id;
      obj["limit"] = 5;
      obj["offset"] = feed.commentList.length;
      if (forcall == "Comment") {
        obj["postId"] = feed.id;
      } else if (forcall == "reply") {
        obj["postId"] = feed.postId;
        obj["pcomment"] = feed.id;
      }

      obj["ordertype"] = "DESC";
      obj["orderby"] = "id";

      this._group.getComments(obj).subscribe(
        (data: any) => {
          if (data.error == 0) {
            if (data.result) {
              for (let i in data.result) {
                this.commentEditbox[data.result[i].id] = data.result[i].comment;
              }
            }
            Array.prototype.push.apply(feed.commentList, data.result);
            //console.log(feed.commentList);
          }
          feed.isCommentLoad = false;
        },
        (error: HttpErrorResponse) => {
          feed.isCommentLoad = false;
          this.msg = "internal server error!";
        }
      );
    }
  }

  showCommentBox(feed) {
    if (Object.keys(this.user).length == 0) {
      // this.needLogin();
      return false;
    }
    this.searchUserInput=[];
    feed.taguserBox = false;
    feed.showAttachment = false;
    if (feed.showCommentBox) {
      feed.showCommentBox = false;
    } else {
      feed.showCommentBox = true;

      /* if(postObj.commentCount > postObj.commentCount && postObj.commentCount < 5){
        postObj.isCommentLoad=true;
        var obj={};
        obj['userId']=this.userData.id;
        obj['ansId']=postObj.id;
        obj['limit']=5;
        obj['offset']=postObj.commentList.length;
      
        this.forumsService.getComments(obj).subscribe((data:any)=>{
         
          if(data.error==0){
            if(data.result){
              for(let i in data.result){  
                this.commentEditbox[data.result[i].id]=data.result[i].comment;
              }
            }
            
            Array.prototype.push.apply(postObj.commentList,data.result); 
            //postObj.postComments.concat(data.result);
           // console.log(postObj.postComments);
          }
          postObj.isCommentLoad=false;



        },(error : HttpErrorResponse)=>{ 
          postObj.isCommentLoad=false;     
          this.msg="internal server error!";
        })


      }
      */
    }
  }

  saveComment(feed, commentValue,searchUserInput) {
    if (commentValue){
      feed.isclickbutton = true;
      let commentObj = {};
      commentObj["comment"] = this._common.checkvideo(commentValue);
      commentObj["postId"] = feed.id;
      commentObj["userId"] = this.user.id;
           let objTag= [];
           let objTagArray=[];
           if(Array.isArray(searchUserInput) && searchUserInput.length>0){
                for(let i of searchUserInput){
                  objTag.push({userId:i.id})   
                  objTagArray.push({user:i})
                }
           }
      commentObj["tagUser"] = objTag;
      this._group.saveComment(commentObj).subscribe(
        (data: any) => {
          feed.isclickbutton = false;
          if (data.error == 0) {
            let commentData = data.result;
            
            commentData.user = {
              firstName: this.user.firstName,
              lastName: this.user.lastName,
              photo: this.user.photo
            };
            commentData.likeCount = 0;
            commentData.groupCommentTags=objTagArray;
            // commentData.commentAttachments=this.currentCommentMediaIds;
            if (!feed.commentList) {
              feed.commentList = [];
            }
           
          
            
            //if(postObj.postComments.length<5){
            feed.commentList.unshift(commentData);
            // console.log(feed.commentList);
            //}
            this.commentEditbox[commentData.id]=commentObj["comment"];

            feed.commentCount += 1;

            feed.showCommentBox = false;
            //  feed.commentMedia=[];
           this.commentbox[feed.id] = "";
            feed.showAnscomment = false;
            this.showPostcomment(feed);
          }
        },
        (error: HttpErrorResponse) => {
          this.msg = "internal server error!";
        }
      );
    }
  }

  commentLike(commentData) {
    if (Object.keys(this.user).length == 0) {
      // this.needLogin();
      //return;
    }
    var obj = {};
    obj["userId"] = this.user.id;
    obj["commentId"] = commentData.id;
    obj["react"] = 1;
    obj['postId'] = commentData.postId;

    if (commentData.mylike) {
      this._group.deleteCommentLike(obj).subscribe(
        (data: any) => {
          if (data.error == 0) {
            commentData.mylike = 0;
            commentData.likeCount -= 1;
          }
        },
        (error: HttpErrorResponse) => {
          this.msg = "internal server error!";
        }
      );
    } else {
      this._group.saveCommentLike(obj).subscribe(
        (data: any) => {
          if (data.error == 0) {
            commentData.mylike = 1;
            commentData.likeCount += 1;
          }
        },
        (error: HttpErrorResponse) => {
          this.msg = "internal server error!";
        }
      );
    }
  }

  replyTextboxShow(commentdata) {
    if (commentdata.isShow) {
      commentdata.isShow = false;
    } else {
      commentdata.isShow = true;

      if (!commentdata.commentList) {
        commentdata.commentList = [];
      }
      if (
        commentdata.commentCount > commentdata.commentList.length &&
        commentdata.commentList.length < 5
      ) {
        commentdata.isCommentLoad = true;
        var obj = {};
        obj["userId"] = this.user.id;
        obj["postId"] = commentdata.postId;
        obj["pcomment"] = commentdata.id;
        obj["limit"] = 5;
        obj["offset"] = commentdata.commentList.length;
        obj["ordertype"] = "DESC";
        obj["orderby"] = "id";

        this._group.getComments(obj).subscribe(
          (data: any) => {
            if (data.error == 0) {
              if (data.result) {
                for (let i in data.result) {
                  this.commentEditbox[data.result[i].id] =
                    data.result[i].comment;
                }
              }
              Array.prototype.push.apply(commentdata.commentList, data.result);
              //postObj.postComments.concat(data.result);
              // console.log(commentdata.commentList);
            }
            commentdata.isCommentLoad = false;
          },
          (error: HttpErrorResponse) => {
            commentdata.isCommentLoad = false;
            this.msg = "internal server error!";
          }
        );
      }
    }
  }

  enableEditor(Obj) {
    if (Object.keys(this.user).length == 0) {
      // this.needLogin();
      return false;
    }
    Obj.isEditor = true;
  }

  /*===================================== Comment ==============================*/
  savereply(commentobj, commentValue) {
    let objthis = this;
    if (commentValue) {
      commentobj.isclickbutton = true;
      let commentInsertObj = {};
      commentInsertObj["comment"] = this._common.checkvideo(commentValue);
      commentInsertObj["postId"] = commentobj.postId;
      commentInsertObj["userId"] = this.user.id;
      commentInsertObj["pcomment"] = commentobj.id;
      //commentInsertObj['mediaids']=[];

      this._group.saveComment(commentInsertObj).subscribe(
        (data: any) => {
          commentobj.isclickbutton = false;
          if (data.error == 0) {
            let commentData = data.result;

            commentData.user = {
              firstName: this.user.firstName,
              lastName: this.user.lastName,
              photo: this.user.photo
            };
            commentData.likeCount = 0;
            if (!commentobj.commentList) {
              commentobj.commentList = [];
            }
            //commentData.commentAttachments=this.currentCommentMediaIds;

            // if(commentobj.commentList.length<5){
            commentobj.commentList.unshift(commentData);
            // }
            this.commentEditbox[commentData.id]=commentData["comment"];
            commentobj.commentCount += 1;
            objthis.replybox[commentobj.id] = "";
            commentobj.commentMedia = [];
            commentobj.isEditor = false;
          }
          //  this.currentCommentMediaIds=[];
        },
        (error: HttpErrorResponse) => {
          this.msg = "internal server error!";
        }
      );
    }
  }

  toggleoption(postObj) {
    if (postObj.showOption) {
      postObj.showOption = false;
    } else {
      postObj.showOption = true;
    }
  }

  openEditComment(commentObj) {
    commentObj.editMode = true;
    commentObj.showOption = false;
  }

  EditComment(commentObj) {
    
    let obj = {};
    obj['id'] = commentObj.id;
    commentObj.isclickbutton = true;
    obj['comment'] = this._common.checkvideo(this.commentEditbox[commentObj.id]);
    this._group.editComment(obj).subscribe((data: any) => {
      commentObj.editMode = false;
      commentObj.isclickbutton = false;
      commentObj.comment = this.commentEditbox[commentObj.id];
    })
  }
  cancelEditComment(commentObj) {
    commentObj.editMode = false;
  }


  deleteComment(commentObj, parentObj, index) {

  
    if(confirm("Do you want to delete ?")){
        var obj = {};
        obj["id"] = commentObj.id;
        this._group.deleteComment(obj).subscribe(
          (data: any) => {
            if (data.error == 0) {
              try {
                parentObj.commentList.splice(index, 1);
                //  if(parentObj.postComments){
                // parentObj.postComments.splice(index,1);       // For Comment
                // }else{
                parentObj.commentCount -= 1; // for reply && comment

                //     }
              } catch (e) {
                //console.log(e);
                this.msg = "internal server error!";
              }
            }
          },
          (error: HttpErrorResponse) => {
            this.msg = "internal server error!";
          }
        );

    }
  }

  editcontent(feed, i) {
    feed.editContent = true;
    this.contentbox[feed.id] = feed.postContent;
  }

  editconversationpost(formData, feed) {
    if (formData.status == "INVALID") {
    } else {
      feed.postContent = this._common.checkvideo(formData.value.content);
      this._group.editPostGroup(feed).subscribe(
        (data: any) => {
          if (data.error == 0) {
            feed.editContent = false;
          } else {
            if (data.message == "Failed to authenticate token.") {
              this.router.navigate(["/"]);
            } else {
              this.msg = data.message;
              this.isError = true;
              this.isSuccess = false;
            }
          }
        },
        (error: HttpErrorResponse) => {
          this.isError = true;
          this.msg = "internal server error!";
        }
      );
    }
  }

  delcontent(feed, index) {
    if (confirm("Are you sure you want to delete this content")) {
      var obj = {};
      obj["id"] = feed.id;
      this._group.deletefeed(obj).subscribe(
        (data: any) => {
          if (data.error == 0) {
            try {
              this.feedData.splice(index, 1);
            } catch (e) {
              this.msg = "internal server error!";
            }
          }
        },
        (error: HttpErrorResponse) => {
          this.msg = "internal server error!";
        }
      );
    }
  }

  //ckeditor Image upload
  ngAfterViewInit() {
    this.imageuploaders.onAfterAddingFile = (item => {
      item.withCredentials = false;
    });
  }

  openNew(content) {

    this.modalReferenceImg = this.modalService.open(content);
  }

  customImageupload(event, content) {
    this.ckeditorevent = event;
    this.openNew(content);

  }
  onFileChangedImage(event) {
    this.imageuploaders.uploadAll();
    this.progress=1;

  }

  onSuccessItemImage(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {

    let data = JSON.parse(response); //success server response
    // console.log(data);
    if (data.error == 0) {
      this.progress=0;
      //  console.log(this.ckeditorevent.name);
      let fileurl = this.global.objectStorage + 'ckeditor/' + data.result.mediaDetail.uploadname;
      let imagetag = "<img src='" + fileurl + "' alt='" + data.result.mediaDetail.title + "'>";
      // console.log(imagetag);       
      CKEDITOR.instances[this.ckeditorevent.name].insertHtml(imagetag);
      this.imageuploaders.clearQueue();
      this.modalReferenceImg.close();
    } else {
      this.msgpopup = "There is some technical problem. Please try again";
      this.imageuploaders.clearQueue();
    }

  }

  onErrorItemImage(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    //console.log('get eroor');   
    let error = JSON.parse(response); //error server response
    this.msgpopup = "There is some technical problem. Please try again";
    this.imageuploaders.clearQueue();
  }

  customdecode(data) {
    return encodeURI(btoa(data));
  }
  makeurl(groupId) {
    //console.log('groupId'+groupId);
    return this.global.websiteUrl + 'groups/' + encodeURIComponent(btoa(groupId));
  }
  sharesocial(sharesocial) {
    sharesocial.action = true;
    this._common.setSocialSharingBox(sharesocial);
  }

  checkpasscode(content) {
    let obj = {};
    obj['passCode'] = content;
    obj['group'] = this.groupId;
    obj['userId'] = this.user.id;
    this._group.addGroupUser(obj).subscribe(
      (data: any) => {
        if (data.error == 0) {
          this.ispasscode = false;
          content = '';
          this.getGroupDetails();
          this.getgroupmemberdetails();
        } else {
          alert(data.message);
        }
      })


  }
  cancelContentBox() {
    this.newconversationbox = false;
  }

  cancelCommentBox(feed) {
    feed.showCommentBox = false;
  }
  cancelreplyBox(commentData) {
    commentData.isEditor = false;
  }

  taguser(feed){
    if(feed.taguserBox ==true){
    feed.taguserBox = false;
    }else{
      feed.taguserBox = true;
    }
  }
  backgroup(){
    this.router.navigate(['/groups/'+this.groupId]);
  }

  public requestAutocompleteItems = (text: string): Observable<any> => {
     let url = this.global.siteUrl+`group/getuser?q=${text}&&g=${this.groupId}&&u=${this.user.id}`;
     return this.http.get(url).map(item => item);
};

getGroupImagePath(path,width,height){
  if(!path){
    path='defaultlarge.png';
  }
if(width!=undefined){
  let res=this.global.objectStorage+this.global.groupProfileFolder+'/'+path;
return res;
}else{
let res=this.global.objectStorage+this.global.groupProfileFolder+'/'+path;
return res;
}

}

getImagePath(path,anonymously,width,height){
  if(!path || anonymously==1){
    path='avatar.png';
  }
// let res=this.global.profileUrl+path;

if(width!=undefined && height!=undefined){
let res=this.global.objectStorage+this.global.profileFolder+'/'+path;
return res;
}else{
let res=this.global.objectStorage+this.global.profileFolder+'/'+path;
return res;
}
}
// pintotop(feed,i){

//  this._group.pintotop({feed:feed.id}).subscribe(
//         (data: any) => {
//           if (data.error == 0) {
//             //this.groupfeed();
//           }
//         },
//         (error: HttpErrorResponse) => {
//           this.msg = "internal server error!";
//         }
//       );
// }


}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/groupdetail/groupdetail.component.ts